import React from 'react'

const MoreIcon = () => (
    <svg 
        fill="#ffffff" 
        width="16px" 
        height="16px" 
        viewBox="0 0 1024 1024" 
        xmlns="http://www.w3.org/2000/svg" 
        stroke="#ffffff"
    >
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
        <g id="SVGRepo_iconCarrier">¨
            <path d="M245.76 512c0 67.865-55.015 122.88-122.88 122.88S0 579.865 0 512s55.015-122.88 122.88-122.88S245.76 444.135 245.76 512zm389.12 0c0 67.865-55.015 122.88-122.88 122.88S389.12 579.865 389.12 512 444.135 389.12 512 389.12 634.88 444.135 634.88 512zm389.12 0c0 67.865-55.015 122.88-122.88 122.88S778.24 579.865 778.24 512s55.015-122.88 122.88-122.88S1024 444.135 1024 512z"></path>
        </g>
    </svg>
)

export default MoreIcon